module.exports = __webpack_public_path__ + "img/edit.2f22abc6.svg";